import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import InputMask from "react-input-mask";
import clsx from "clsx";
import {
  OVERRIDE_OPERATORS,
  OVERRIDE_TYPES,
} from "../../../../consts/overrides";
import { OverrideRowButtons } from "./OverrideRowButtons";
import { memo } from "react";
import { palette } from "../../../../theme/palette";

const useStyles = makeStyles({
  row: {
    maxHeight: "46px",
  },
  disabled: {
    pointerEvents: "none",
    "& input": {
      color: palette.typography.black.disabled,
    },
  },
});

export const OverrideRow = memo(
  ({
    showMinus = false,
    disableAdd = false,
    disableMinus = false,
    disableSelectType = false,
    row,
    error,
    onChange,
    onPlusClick,
    disabled = false,
    onMinusClick,
  }) => {
    const styles = useStyles();

    const handleChange = (e) => {
      onChange && onChange({ ...row, [e.target.name]: e.target.value });
    };

    return (
      <Grid container direction={"row"} spacing={2} className={styles.row}>
        <Grid item xs={5}>
          <FormControl fullWidth variant={"outlined"}>
            <InputLabel id="override-type">Type</InputLabel>
            <Select
              label={"Type"}
              labelId="override-type"
              name={"selectType"}
              onChange={handleChange}
              value={row.selectType}
              disabled={disableSelectType || disabled}
            >
              {Object.entries(OVERRIDE_TYPES).map(([value, option], index) => (
                <MenuItem key={index} value={value}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2}>
          <FormControl fullWidth variant={"outlined"}>
            <InputLabel id="override-operator">Operator</InputLabel>
            <Select
              label={"Operator"}
              labelId="override-operator"
              name={"operatorType"}
              onChange={handleChange}
              value={row.operatorType || ""}
              disabled={disabled}
            >
              {Object.values(OVERRIDE_OPERATORS).map((operator, index) => (
                <MenuItem key={index} value={operator}>
                  {operator}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <InputMask
            mask="99:99"
            onChange={handleChange}
            disabled={disabled}
            value={row.selectTime}
          >
            {() => (
              <TextField
                className={clsx(disabled && styles.disabled)}
                variant={"outlined"}
                label={"Time"}
                name={"selectTime"}
                error={!!error}
                FormHelperTextProps={{
                  style: { marginLeft: "0px" },
                }}
                helperText={error}
              />
            )}
          </InputMask>
        </Grid>
        <Grid item xs={2} container direction={"row"}>
          <OverrideRowButtons
            showPlus={true}
            showMinus={showMinus}
            disableAdd={disabled || disableAdd}
            disableMinus={disabled || disableMinus}
            onPlusClick={onPlusClick}
            onMinusClick={onMinusClick}
          />
        </Grid>
      </Grid>
    );
  }
);
